import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import TailwindButton from '../components/TailwindButton';
import { TakweenSurveyRouteState } from './types';

const TakweenSurveyConfirmation: React.FC = () => {
  const history = useHistory();
  const location = useLocation<TakweenSurveyRouteState>();

  return (
    <div className='flex min-h-screen items-center justify-center bg-gray-50 p-4'>
      <div className='w-full max-w-lg rounded-lg bg-white p-10 text-center shadow-sm'>
        <h1 className='m-0 text-[3rem] font-bold text-gray-800'>Survey submitted</h1>
        <p className='mb-7 mt-4 text-[1.7rem] text-gray-500'>
          The student survey answers have been recorded successfully.
        </p>
        <TailwindButton variant='secondary' onClick={() => history.push('/takween/survey/students', location.state)}>
          Go Back
        </TailwindButton>
      </div>
    </div>
  );
};

export default TakweenSurveyConfirmation;
